import type { ProductIdentifier } from "@s2z-platform/constants";
import type { YYYYMMDDDateString } from "../../common";

type PermissionsLimitsObj = {
  max: number;
  usage: number;
  remaining: number;
};

export type PermissionsLimits = {
  footprintFreeSaves?: PermissionsLimitsObj;
};

/** products that define permissions */
export const PERMISSION_PRODUCT_IDENTIFIERS = [
  "business-premium-recurring",
  "business-consultancy-recurring",
  "business-consultancy-onetime",
  "business-premium-onetime",
  // You can add more product identifiers here
] as const satisfies readonly ProductIdentifier[];

export type PermissionProductIdentifier =
  (typeof PERMISSION_PRODUCT_IDENTIFIERS)[number];

export const isPermissionProduct = (
  id: ProductIdentifier,
): id is PermissionProductIdentifier =>
  PERMISSION_PRODUCT_IDENTIFIERS.includes(id as PermissionProductIdentifier);

export type ApiProductPermissions = {
  permissions: Record<
    PermissionProductIdentifier,
    { permitted: true; expiry: YYYYMMDDDateString } | { permitted: false }
  >;
  limits: PermissionsLimits;
};
